import { render, staticRenderFns } from "./inactive-clients-filter-dropdown.vue?vue&type=template&id=2ef2c3ee"
import script from "./inactive-clients-filter-dropdown.vue?vue&type=script&lang=js"
export * from "./inactive-clients-filter-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports